import React, { useEffect, useState } from 'react'

import './ImageWrap.css'

function ImageWrap({images}) {

    const [imageArray, setImageArray] = useState(images);

    useEffect(() => {

        if (!images) {
            const backupImages = [
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-4-smil-valestrand-2019.jpg',
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-5-2020.jpg',
                'https://smorasstats.com/v4/wp-content/uploads/2020/01/nil-smil-2019-1.jpg',
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-1-smil-voss-1024x399.jpg',
                'https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/gallery%2F1600869502213_83455657_2775865449147161_4585439258533167104_o.jpg?alt=media&token=356bf80b-df3e-4e10-9bd6-720c9dd41c67',
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-3-smil-ab-2019.jpg',
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-4-smil-valestrand-2019.jpg',
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-7.jpeg',
                'https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/gallery%2F1600940979339_120117826_3381478188585881_5307528275822929335_o.jpg?alt=media&token=8744338e-4398-49c7-b6ce-6226fc0171c9',
                'https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/gallery%2F1600941077476_120183156_3381481691918864_4400075164636112458_o.jpg?alt=media&token=cbf4f562-b7c2-4a4b-9acc-f948a7603450',
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-6-smil-nymark-2020.jpg',
                'https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/gallery%2F1600939972883_70557928_2492183450848697_3007585771403083776_o.jpg?alt=media&token=8ecd5af5-2e94-4632-9cad-7a3c1e950b7a',
                'https://smorasstats.com/v4/wp-content/uploads/2020/10/wide-2-asane-oygarden-2020.jpg',
                'https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/gallery%2Fpexels-pixabay-46792.jpg?alt=media&token=46047c51-eb41-4958-83af-33055ea29c85'
            ]
            setImageArray(backupImages);
        }

    }, [images])


    return (
        <div className="gallery">
            {imageArray?.map((image, index) => {
                return (
                    <figure className={`gallery__item--${index+1}`}>
                        <img src={image} alt={`media-item-${index+1}`} className="gallery__img" />
                    </figure>
                )
            })}
        </div>
    )

}
export default ImageWrap